module.exports = require('./LicenseContactsChangeApplicationView');
